module.exports = require('./LicenseContactsChangeApplicationView');
